import { render } from "./cdrBatchManagement.vue?vue&type=template&id=2b24af7e&scoped=true"
import script from "./cdrBatchManagement.vue?vue&type=script&lang=js"
export * from "./cdrBatchManagement.vue?vue&type=script&lang=js"

import "./cdrBatchManagement.vue?vue&type=style&index=0&id=2b24af7e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2b24af7e"

export default script